export const checkUpdateTimeActionTypes = {
    DATA_PROVIDER: "CHECK_UPDATE_TIME_FOR_DATA_PROVIDER",
    DP_SERVICE: "CHECK_UPDATE_TIME_FOR_DP_SERVICE",
    DP_SOURCE: "CHECK_UPDATE_TIME_FOR_DP_SOURCE",
    COUNTRY: "CHECK_UPDATE_TIME_FOR_COUNTRY",
    BILLING_GROUP: "CHECK_UPDATE_TIME_FOR_BILLING_GROUP",
}

export const activityLoggerActionTypes = {
    LOG_CHANGE: "LOG_CHANGE",
    LOG_STATUS_CHANGE: "LOG_STATUS_CHANGE",
}

export const approvalsActionTypes = {
    SET_APPROVAL: "APPROVING_THIS_RESOURCE",
    REMOVE_APPROVAL: "UN-APPROVING_THIS_RESOURCE",
}

export const navigateActionTypes = {
    SET_LINK: "SET_LINK",
    REMOVE_LINK: "REMOVE_LINK"
}